import { useMemo } from "react";
import {
  EditButton,
  DeleteButton,
  Stack,
  CreateButton,
  MenuItem,
  TextField,
  Typography,
  useDataGrid,
  DataGrid,
  List,
} from "@pankod/refine-mui";
import { useSelect } from "@pankod/refine-core";
import { itIT } from "@mui/x-data-grid";
import useLocales from "locales/useLocales";
import useAuth from "contexts/AuthContext";

export default function CompList() {
  const { currentLang, defaultLang } = useLocales();
  //const owner = JSON.parse(localStorage.getItem("user")).id;
  const auth = useAuth();
  const owner = auth.user?.id ? auth.user?.id : "";

  let filter = [];
  if (auth.user.role.name != "admin")
    filter = [
      {
        field: "facility.owner.id",
        operator: "eq",
        value: owner,
      },
    ];

  const {
    dataGridProps,
    sortingMode,
    sortModel,
    onSortModelChange,
    setFilters,
  } = useDataGrid({
    metaData: {
      locale: defaultLang,
      populate: {
        facility: {
          fields: "businessName",
        },
        localizations: true,
        price_type: true,
      },
    },
    permanentFilter: filter,
  });

  const columns = useMemo(
    () => [
      { field: "name", headerName: "Nome", flex: 1, minWidth: 300 },
      {
        field: "facility",
        headerName: "Struttura",
        valueGetter: ({ row }) => {
          const value = row.facility?.businessName || "N/A";
          return value;
        },
        flex: 1,
        minWidth: 200,
      },
      { field: "price", headerName: "Prezzo", flex: 1, minWidth: 200 },
      {
        field: "price_type",
        headerName: "Tipologia prezzo",
        valueGetter: ({ row }) => {
          const value = row.price_type?.name || "N/A";
          return value;
        },
        flex: 1,
        minWidth: 300,
      },
      {
        headerName: "Azioni",
        field: "actions",
        minWidth: 50,
        renderCell: function render(params) {
          return (
            <Stack direction="row" spacing={1}>
              <EditButton hideText recordItemId={params.row.id} />
              <DeleteButton hideText recordItemId={params.row.id} />
            </Stack>
          );
        },
      },
    ],
    []
  );

  const { options: facilityAC } = useSelect({
    resource: "strutture",
    optionLabel: "businessName",
    optionValue: "id",
    filters: [
      {
        field: "owner.id",
        operator: "eq",
        value: owner,
      },
      { field: "gestore", operator: "eq", value: "false" },
    ],
  });
  const options = [{ value: -1, label: "Tutte" }, ...facilityAC];

  const handleFilter = (e) => {
    const selected = e.target.value;
    console.log(e.target.value);
    //const match = options.map((item) => item.value).indexOf(e.target.value);
    if (selected >= 0)
      setFilters([
        {
          field: "facility.id",
          operator: "eq",
          value: selected,
        },
      ]);
    else {
      setFilters([]);
    }
  };

  return (
    <List
      resource="extras"
      //createButtonProps={{ size: "small" }}
      headerButtons={<CreateButton>Nuovo</CreateButton>}
      headerButtonProps={{ size: "small" }}
      title={<Typography variant="h5">Servizi Extra</Typography>}
    >
      <TextField
        select
        value={-1}
        onChange={handleFilter}
        sx={{ width: 1 / 2, mb: 2 }}
        label={"Filtra per struttura"}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <DataGrid
        {...dataGridProps}
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        sortingMode={sortingMode}
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        autoHeight
      />
    </List>
  );
}
